import React from "react";
import {connect} from "react-redux";
import {IStore} from "../../../store/reducers";
import actionTypes from "../../../store/actionTypes";


interface IProps {
}

interface Istate {
}


class Chat extends React.Component<IProps, Istate> {

    state:Istate = {
    }


    render() {

        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    height: '100%',
                    backgroundColor: "#ECECEC"
                }}
            >
                Chat
            </div>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(Chat);
